module.exports = __webpack_public_path__ + "img/album21_37.744f031d.jpg";